import { render, staticRenderFns } from "./EditDomainOverallDialog.vue?vue&type=template&id=496ca9c0&scoped=true"
import script from "./EditDomainOverallDialog.vue?vue&type=script&lang=js"
export * from "./EditDomainOverallDialog.vue?vue&type=script&lang=js"
import style0 from "./EditDomainOverallDialog.vue?vue&type=style&index=0&id=496ca9c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ca9c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
